if (!customElements.get('pp-before-after')) {
  customElements.define('pp-before-after', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ppBeforeAfterReady === 'true') return;
      const input = this.querySelector('input[type="range"]');
      if (!input) return;
      this.dataset.ppBeforeAfterReady = 'true';
      input.addEventListener('input', () => this.style.setProperty('--position', `${input.value}%`));
    }
  });
}
